import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-completeness-ring',
  templateUrl: './completeness-ring.component.html',
  styleUrls: ['./completeness-ring.component.scss']
})
export class CompletenessRingComponent implements OnInit {
  assetsUrl = environment.app.assetsUrl;

  constructor() { }

  @Input() user: any;
  @Input() width = '100px';

  ngOnInit(): void {
  }

  completenessColor(completeness: number) {
    if (completeness < 35)
      return '#c50000';
    if (completeness < 50)
      return '#EE8200';
    if (completeness < 80)
      return '#95CA00';
    return '#008a5f';
  }


}
